// extracted by mini-css-extract-plugin
export var editButton = "_pr-0";